import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import ViewJuridico from "../views/ViewJuridico";

const Juridico: React.FC = () => (
  <>
    <ContatoZap />

    <ViewAppBar />

    <ViewJuridico />
    <ViewFooter />
  </>
);
export default Juridico;
